import { c as _c } from "react/compiler-runtime";
import { CdnImage } from '@cc-shopping/ui/primitives/CdnImage';
import { Box, Link, Typography } from '@mui/material';
import type { ReactNode } from 'react';
export type AskOurExpertsContentProps = {
  name: string;
  title: string;
  avatarUrl?: string | null;
  expertUrl?: string | null;
  renderedChildren: ReactNode;
};
export const AskOurExpertsContent = t0 => {
  const $ = _c(24);
  const {
    renderedChildren,
    name,
    title,
    avatarUrl,
    expertUrl
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      flexDirection: "column"
    };
    t2 = {
      margin: "1rem 0",
      padding: ".5rem 1.5rem",
      borderRadius: "4px",
      borderLeft: ".25rem solid #D8D9DA"
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      fontSize: {
        xs: "1rem",
        sm: "1.1rem"
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== renderedChildren) {
    t4 = <blockquote style={t2}><Box sx={t3}>{renderedChildren}</Box></blockquote>;
    $[3] = renderedChildren;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      display: "flex",
      justifyContent: "flex-end",
      gap: 2
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== avatarUrl || $[7] !== name) {
    t6 = avatarUrl && <CdnImage width={72} height={72} style={{
      marginRight: "8px",
      borderRadius: "50%"
    }} src={avatarUrl} alt={`${name} avatar`} />;
    $[6] = avatarUrl;
    $[7] = name;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      display: "flex",
      flexDirection: "column",
      gap: 1
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== expertUrl || $[11] !== name) {
    t8 = expertUrl ? <Link href={expertUrl} aria-label={`Learn more about ${name}`} title={`Learn more about ${name}`}><Typography sx={{
        fontSize: "18px",
        fontWeight: "bold"
      }}>{name}</Typography></Link> : <Typography sx={{
      fontSize: "18px",
      fontWeight: "bold"
    }}>{name}</Typography>;
    $[10] = expertUrl;
    $[11] = name;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== title) {
    t9 = <Typography>{title}</Typography>;
    $[13] = title;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8 || $[16] !== t9) {
    t10 = <Box sx={t7}>{t8}{t9}</Box>;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t6) {
    t11 = <Box sx={t5}>{t6}{t10}</Box>;
    $[18] = t10;
    $[19] = t6;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t4) {
    t12 = <Box sx={t1}>{t4}{t11}</Box>;
    $[21] = t11;
    $[22] = t4;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};